<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input
              clearable
                v-model="queryParam.keywords"
                placeholder="搜索文章标题"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="分类">
              <a-cascader
                :options="cateOptions"
                placeholder="选择分类"
                changeOnSelect
                v-model="queryParam.cate_ids"
                :fieldNames="{
                  label: 'title',
                  value: 'key',
                  children: 'children',
                }"
              />
            </a-form-item>
          </a-col>  
          <a-col :md="(!advanced && 6) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="
                (advanced && { float: 'right', overflow: 'hidden' }) || {}
              "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => (queryParam = {})"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
 
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd" >新建</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="setAllStatus(1)" key="1">显示</a-menu-item>
          <a-menu-item @click="setAllStatus(2)" key="2">隐藏</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>
    <s-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        :alert="false"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
        <span slot="status" slot-scope="text,record">
          <template >
            <a-badge status="success" v-if="record.status==1" text="显示" />
            <a-badge status="default" v-else text="隐藏" />
            </template>
        </span>
        <span slot="title1" slot-scope="text,record">
          <template >
            {{record.title}}
            <br/>
            <a-tag :key="cindex" v-for="(cate,cindex) in record.cates">{{cate.name}}</a-tag>
            </template>
        </span>
        <span slot="update_time" slot-scope="text,record">
          <template >
            {{moment(record.update_time*1000).format('YYYY-MM-DD HH:mm:ss')}}<br/>
            {{record.edit_user_name}}<br/> 
            </template>
        </span>
        <span slot="create_time" slot-scope="text,record">
          <template >
            {{moment(record.create_time*1000).format('YYYY-MM-DD HH:mm:ss')}}<br/>
            {{record.user_name}}<br/> 
            </template>
        </span>
        

          <span slot="rank" slot-scope="text,record">
        <template >
        <editable-cell :text="text" @change="onRankChange(record.id, 'rank', $event)"/>
        </template>
      </span>

          <span slot="action" slot-scope="text, record">
            <template>
              <a @click="handleEdit(record)">编辑</a>
              <a-divider type="vertical" />
            </template>
            <a-dropdown>
              <a class="ant-dropdown-link">
                更多 <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item >
                  <a-popconfirm title="确定复制文章吗?" @confirm="onCopy(record)"  okText="确定" cancelText="取消">
                    <a href="javascript:;">复制</a>
                  </a-popconfirm>
                </a-menu-item>
                <a-menu-item >
                    <a href="javascript:;" @click="onShare(record)">分享</a>
                </a-menu-item>
                <a-menu-item >
                    <a href="javascript:;" @click="handleCommentManage(record)">评论</a>
                </a-menu-item>
                <a-menu-item >
                  <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="onDelete(record)"  okText="确定" cancelText="取消">
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
        </s-table>




    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-tabs v-model:activeKey="activeFormName" @change="handleFormTabClick">
            <a-tab-pane :key="1" tab="基础信息"></a-tab-pane>
            <!-- <a-tab-pane :key="2" tab="其他信息"  ></a-tab-pane>  -->
            <a-tab-pane :key="3" tab="操作日志"  >
              <div style="padding: 20px">
            <a-timeline>
              <a-timeline-item v-for="log in formData.logList" :key="log.id">
                {{ log.create_time | timeFormat }}
                <b>{{ log.user_name }}</b>
                {{ log.type }}
                <!-- <span v-if="log.note" class="gray">备注:{{ log.note }}</span> -->
              </a-timeline-item>
            </a-timeline>
          </div>
              </a-tab-pane> 
          </a-tabs>
          <div v-show="activeFormName==1">
              <a-form-item
                    label="所属分类"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
            >
              <a-tree-select
                      v-decorator="[
                    'cate_ids',
                    {rules: [{ required: true, message: '请输入选择分类' }]}
                  ]"
                      style=" width: 90% ; margin-right: 10px; "
                      :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                      :treeData="cateOptions"
                      allowClear
                      multiple
                      treeNodeFilterProp="title"
                      placeholder='请选择分类'
                      treeDefaultExpandAll
                      v-model="formData.cate_ids"
              >
              </a-tree-select>
            </a-form-item>

            <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="标题"
                    hasFeedback
            >
              <a-input v-decorator="[
            'title',
            {rules: [{ required: true, message: '请输入文章标题' }]}
          ]"
                      placeholder="请输入文章标题"/>
            </a-form-item>

            <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="描述"
                    hasFeedback
            >
              <a-textarea autosize v-decorator="[
            'desc',
            {rules: []}
          ]"
                          placeholder="请输入描述"/>
            </a-form-item>

            <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="相关图片"
                    hasFeedback
            >
              <pic-uploader
                      :file-list="formData.pics"
              />
            </a-form-item>

            <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="相关附件"
                    hasFeedback
            >
              <file-uploader
                      :file-list="formData.files"
              />
            </a-form-item>

            <a-form-item
                    v-if="visible"
                    label="正文"
                    :labelCol="labelCol"
                    :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 24 },}"
            >

              <UEditor ref="ue" style="width: 100%; height:520px;" :ueditorContent.sync="formData.content" ></UEditor>
            </a-form-item>

            <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="状态"
                    hasFeedback
            >
              <r-switch  :formData="formData" field="status" :checkedValue="1" :unCheckedValue="2"  checkedChildren="显示" unCheckedChildren="隐藏" />
            </a-form-item>
            
          </div>

          <div v-show="activeFormName==2">
            <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="境外交流-活动时间"
                    hasFeedback
            >
            <a-date-picker v-model:value="formData.jingwai_start_time" placeholder="选择日期" 
            format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"  />
            </a-form-item>
            <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="境外交流-报名截止"
                    hasFeedback
            >
            <a-date-picker v-model:value="formData.jingwai_baoming_end" placeholder="选择日期" 
            format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"  /> 
            </a-form-item>
            <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="境外交流-活动关联通知文件"
                    hasFeedback
            >
            <content-picker
                style="width: 500px; margin-right: 10px;"
                :formData="formData"
                field="jingwai_tongzhi_id"
              />
            </a-form-item>



            <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="投票网址"
                    hasFeedback
            >
              <a-input v-decorator="[
            'vote_url', 
          ]"
                      placeholder="请输入第三方投票网址"/>
            </a-form-item>



            <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="直播开始时间"
                    hasFeedback
            >
            <a-date-picker v-model:value="formData.live_time" placeholder="选择日期" 
            format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss"  /> 
            </a-form-item>



            <a-form-item
                    label="直播间列表"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
            >
                <div v-for="(item,k) in formData.live_room_list" :key="k">
                    <a-input style=" width: 45%; margin-right: 10px" v-model="item.name" placeholder="直播间名称"/>
                    <a-input style=" width: 45%; margin-right: 10px" v-model="item.value" placeholder="直播间ID"/>
                    <a-icon
                            class="dynamic-delete-button"
                            type="minus-circle-o"
                            @click="() => removeExtraField(k)"
                    />
                </div>
                <div>
                    <a-button
                            type="dashed"
                            style="width: 100%"
                            @click="addExtraField"
                    >
                        <a-icon type="plus"/>
                        增加直播间
                    </a-button>
                </div>

            </a-form-item>


            <!-- <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="直播房间ID"
                    hasFeedback
            >
              <a-input v-decorator="[
            'live_room_id', 
          ]"
                      placeholder="请输入小程序直播房间id"/>
                       
                      <p 
          v-clipboard:copy="lurl.media_url"
          v-clipboard:success="onCopy2"
          v-clipboard:error="onError"
           :key="lkey" v-for="(lurl,lkey) in live_urls"><a href="#nogo"  >【回放地址{{lkey+1}}】过期时间{{lurl.expire_time}}[复制]</a></p>
                       
            </a-form-item> -->

          </div>
          

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
      :maskClosable="false"
      title="分享"
      v-model="shareShow"
      @ok="shareShow = false"
    > 
      <div class="qrcode" v-if="shareShow" ref="qrcode"></div> 
      <p>文章详情地址</p>
      <p>
        {{ shareUrl }} &nbsp;&nbsp;
        <a
          v-clipboard:copy="shareUrl"
          v-clipboard:success="onCopy2"
          v-clipboard:error="onError"
          >点此复制</a
        >
      </p>
    </a-modal>




    <a-modal
        :maskClosable="false"
            title="评论管理"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="commentVisible"
            @ok="commentVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table :columns="commentColumns" :dataSource="kaojiCommentList" :pagination="commentPagination"
                   @change="handleCommentTableChange"
                   rowKey="id" :scroll="{ y: 300 }" bordered>
            <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" class='custom-filter-dropdown'>
              <a-input
                      v-model="commentQuery.keywords"
                      placeholder="搜索姓名"
                      style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                      type='primary'
                      @click="commentSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                      @click="commentSearchReset(selectedKeys, confirm)"
                      size="small"
                      style="width: 90px"
              >重置</a-button>
            </div>
            <span slot="name" slot-scope="text,record">
              {{record.user_name}}
            </span>

      <span slot="is_show" slot-scope="text,record">  
          <a-dropdown :trigger="['click']"> 
          <a-tag v-if="record.is_show==1" color="green">前台可见 <a-icon type="form"/></a-tag>
          <a-tag v-else-if="record.is_show==2">前台不可见 <a-icon type="form"/></a-tag> 
      <a-menu slot="overlay" >
        <a-menu-item key="0" @click="setShow(2,record)" v-if="record.is_show==1 ">
          <a>前台不可见</a>
        </a-menu-item>
        <a-menu-item key="1" @click="setShow(1,record)" v-if="record.is_show==2 ">
          <a>前台可见</a>
        </a-menu-item> 
      </a-menu>
    </a-dropdown> 
      </span>
            <span slot="action" slot-scope="text,record">
              <template >
                <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="onCommentDelete(record)"  okText="确定" cancelText="取消">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </span>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>

  </a-card>

</template>

<script>
import STable from '@/components/table/'
import UEditor from '@/components/UEditor/'
import EditableCell from '@/components/EditableCell/'
import RSwitch from '@/components/RSwitch/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import ContentPicker from "@/components/ContentPicker/";
import moment from 'moment'
import QRCode from 'qrcodejs2'


  import { getTopicList ,getTopicDetail,editTopic,getActivityList,addTopic,deleteTopic,setRank,getCommentList,deleteComment,setCommentShow } from '@/api/topic'

import { getCateTreeList, getContentList,editContent,addContent,getContentDetail ,setContentRank,deleteContent,copyContent,setContentAllStatus,getLiveList } from '@/api/cms'

import "moment/locale/zh-cn";
moment.locale("zh-cn");

export default {
  name: 'ContentList',
  components: {
    STable,
    EditableCell,
    RSwitch,
    PicUploader,
    FileUploader,
    UEditor,
    ContentPicker,
  },
  data () {
    return {
      visible: false,
      advanced:false,
      saveLoading: false,
      shareShow:false,
      shareUrl:'',
      openKeys: [ ], 
      // 查询参数
      queryParam: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: this.$form.createForm(this),
      mdl: {},
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id'
        },
        {
          title: '标题',
          dataIndex: 'title',
          scopedSlots: { customRender: 'title1' },
        },
        {
          title: '排序',
          dataIndex: 'rank',
          scopedSlots: { customRender: 'rank' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          width:150,
          filters: [
            {
              text: '显示',
              value: '1'
            },
            {
              text: '隐藏',
              value: '2'
            }],
          filterMultiple: false,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '最后更新',
          dataIndex: 'update_time',
          scopedSlots: { customRender: 'update_time' },
          // customRender: (text) =>  {
          //   return moment(text*1000).format('YYYY-MM-DD HH:mm:ss')+'<>';
          // }
        },
        {
          title: '发布时间',
          dataIndex: 'create_time',
          scopedSlots: { customRender: 'create_time' },
          // customRender: (text) =>  {
          //   return moment(text*1000).format('YYYY-MM-DD HH:mm:ss')+'<>';
          // }
        },
        {
          table: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' },
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        this.queryParam.status = 0;
        this.queryParam = Object.assign(this.queryParam,parameter);
        if(parameter.status && parameter.status.length>0){
          this.queryParam.status =  parameter.status[0];
        }

        this.queryParam.cate_id = 0;
        if (this.queryParam.cate_ids && this.queryParam.cate_ids.length) {
          this.queryParam.cate_id = [...this.queryParam.cate_ids].pop();
        }

        return getContentList(this.queryParam)
          .then(res => {
            return res.data
          })

      },
      cateTree: [],
      cateOptions: [],
      selectedRowKeys: [],
      selectedRows: [],
      commentVisible:false,
      activeFormName:1,
        //领取人员表头
        commentColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '80px'
          },
          {
            title: '用户名',
            dataIndex: 'user_name',
            width:'150px',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'name',
            }
          },
          {
            title: '内容',
            width:'150px',
            dataIndex: 'content'
          },
          {
            title: '发布时间',
            width:'150px',
            dataIndex: 'create_time',
            customRender: (text) =>  {
              return moment(text*1000).format('YYYY-MM-DD HH:mm:ss');
            }
          },
          {
            title: '可见度',
            dataIndex: 'is_show',
            width: 100,
            scopedSlots: { customRender: 'is_show' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: 200,
            scopedSlots: { customRender: 'action' },
          }
        ],
        commentPagination:{
        },
        commentQuery:{
          kaoji_id:0,
          status:0,
          page:1,
          keywords:undefined
        },
        kaojiCommentList:[],
        live_urls:[],
      formData : {
        id:0,
        title: '',
        cate_ids:[],
        desc: '',
        pic: [],
        logList:[],
        pics: [],
        files: [],
        live_time: '',
        live_room_id: '',
        live_room_list: [],
        jingwai_baoming_end: '',
        jingwai_start_time: '',
        content:'',
        rank:0,
        jingwai_tongzhi_id:'',
        status: 1
      }
    }
  },
  created () {
    getCateTreeList().then(res => {
      console.log('getCateTreeList',res);
      this.cateTree = res.data
      this.cateOptions = res.data
    })
  },
  methods: {
    moment,
    handleCancel(){
      this.visible = false
    },
    // 增
    handleAdd() {
      let that = this;
      this.visible = true;
      this.form.resetFields();
      console.log('handleAdd');
      that.formData = {
        id:0,
        cate_ids:[],
        title: '',
        desc: '',
        pic: [],
        pics: [],
        logList:[],
        files: [],
        live_time: '',
        live_room_id: '',
        live_room_list:[],
        jingwai_baoming_end: '',
        jingwai_start_time: '',
        content:'',
        rank:0,
        jingwai_tongzhi_id:0,
        status: 1
      };
      setTimeout( () =>{
        that.form.setFieldsValue({ ...this.formData });
      },100);
    },
    handleFormTabClick(value){
      console.log('handleFormTabClick',this.activeFormName)
    },
    handleCommentManage(record) {
      let self = this
      self.commentQuery.topic_id = record.id;
      self.commentQuery.type = 'cms'
      self.commentQuery.keywords = undefined;
      self.commentQuery.status = undefined;
      self.commentPagination.page = 1;
      self.fetchCommentList();
      this.commentVisible = true
    },


      fetchCommentList(){
        let self = this
        getCommentList(Object.assign(self.commentQuery,self.commentPagination)).then(res => {
          self.kaojiCommentList = res.data.list
          self.commentPagination.total = res.data.total
        })
      },

      commentSearch(selectedKeys,confirm){
        let self = this
        confirm();
        self.fetchCommentList();
      },
      commentSearchReset(selectedKeys,confirm){
        let self = this;
        confirm();
        self.commentQuery.keywords = undefined;
        self.fetchCommentList();
      },
      handleCommentTableChange(pagination, filters, sorter) {
        console.log('filters',filters);
        let that = this;
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        that.pagination = pager;
        that.commentQuery.page = pagination.current;
        that.fetchCommentList();
      },


      onCommentDelete(record){
        let self = this;
        deleteComment({
          id:record.id
        }).then(res => {
          self.$message.success('删除成功')
          self.fetchCommentList();
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })
      },
    // 改
    handleEdit(record) {
      let self = this
      getContentDetail({ id: record.id }).then(res => {
        setTimeout(()=>{
          self.form.setFieldsValue({ ...res.data })
        },1)
        res.data.jingwai_baoming_end = (res.data.jingwai_baoming_end && res.data.jingwai_baoming_end!='0000-00-00')? moment(res.data.jingwai_baoming_end, 'YYYY-MM-DD'):'', 
        res.data.jingwai_start_time =  (res.data.jingwai_start_time && res.data.jingwai_start_time!='0000-00-00')? moment(res.data.jingwai_start_time, 'YYYY-MM-DD'):'', 
        res.data.live_time =  (res.data.live_time && res.data.live_time!='0000-00-00 00:00:00')? moment(res.data.live_time, 'YYYY-MM-DD HH:mm:ss'):'', 

        self.formData = Object.assign(self.formData, res.data) //尼玛 日期选择器有bug 必须这样赋值
        self.formData.id = res.data.id;
        self.getLiveRoomUrls()
      })
      
      this.visible = true
    },

    addExtraField() {
        if (this.formData.live_room_list.length && this.formData.live_room_list[this.formData.live_room_list.length - 1].name == '') {
            return false;
        }
        this.formData.live_room_list.push({'name': '', 'value': ''});
    },
    removeExtraField(k) {
        this.formData.live_room_list.splice(k, 1);
    },
    getLiveRoomUrls(){
      let that = this;
      if(this.formData.live_room_id>0){
        getLiveList({
          room_id:this.formData.live_room_id
        }).then(res =>{
          that.live_urls = res.data.filter(item =>{
            return item.media_url.indexOf('.mp4')>0
          }) 
        })
      }
    },

    onCopy2(e) {
      this.$message.success("复制成功");
    },
    onError(e) {
      this.$message.error("复制失败");
    },
    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true;
          let formData = {
            id:self.formData.id,
            title: values.title,
            vote_url: values.vote_url,
            cate_ids: values.cate_ids,
            desc: values.desc,
            live_room_id: values.live_room_id,
            live_room_list: self.formData.live_room_list,
            pic:self.formData.pic,
            pics:self.formData.pics,
            files:self.formData.files,
            content:self.formData.content,
            status:self.formData.status,
            jingwai_baoming_end: self.formData.jingwai_baoming_end? self.formData.jingwai_baoming_end.format("YYYY-MM-DD"):null,
            jingwai_start_time:self.formData.jingwai_start_time?self.formData.jingwai_start_time.format("YYYY-MM-DD"):null,
            live_time:self.formData.live_time?self.formData.live_time.format("YYYY-MM-DD HH:mm:ss"):null,
            jingwai_tongzhi_id:self.formData.jingwai_tongzhi_id,
          };
          if(self.formData.id) {
            editContent(formData).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }else{
            addContent(formData).then(res => {
              self.$message.success('新增成功')
              self.$refs.table.refresh(false)
              self.visible = false
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        }
      })
    },

    setShow(status, record) {
      let self = this;
      setCommentShow({
        id: record.id,
        show: status
      })
          .then(res => {
            self.fetchCommentList();
          })
          .catch(err => {
            self.$message.error(err.data.msg)
          })
    },
    onDelete(record) {
      let self = this
      deleteContent({ id: record.id }).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh(false)
      }).catch(err =>{
        self.$message.error(err.data.msg)
      })
    },
    onCopy(record) {
      let self = this
      copyContent({ id: record.id }).then(res => {
        self.$message.success('复制成功')
        self.$refs.table.refresh(false)
      }).catch(err =>{
        self.$message.error(err.data.msg)
      })
    }
      ,
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },
    handleCateClick(e){
      let self = this;
      console.log('handleCateClick',e)
      self.queryParam.cate_id = e.key;
      self.$refs.table.refresh(false)
    },

    setAllStatus(status){
      let self = this;
      setContentAllStatus({
        ids:self.selectedRowKeys,
        status:status,
      })
              .then(res => {
                self.$message.success('设置成功')
                self.$refs.table.refresh(false)
              })
    },

    onShare(record){
      this.shareShow = true
      this.shareUrl = record.h5_url
      // new QRCode(this.$refs.qrcode, record.h5_url);
      setTimeout(() =>{
        var qrcode = new QRCode(this.$refs.qrcode, {
              text: record.h5_url, // 需要转换为二维码的内容
              width: 100,
              height: 100,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: QRCode.CorrectLevel.H
          }) 
      },200)
    },
    onRankChange(key, dataIndex, value) {
      let self = this;
      setContentRank({
        id: key,
        rank:value
      }).then(res => {
        self.$refs.table.refresh(false)
      }).catch(err =>{
        self.$message.error(err.data.msg)
      })
    },

    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
  }
}
</script>

<style lang="less">
  .qrcode img{margin: 0 auto;}
  .custom-tree {

    /deep/ .ant-menu-item-group-title {
      position: relative;
      &:hover {
        .btn {
          display: block;
        }
      }
    }

    /deep/ .ant-menu-item {
      &:hover {
        .btn {
          display: block;
        }
      }
    }

    /deep/ .btn {
      display: none;
      position: absolute;
      top: 0;
      right: 10px;
      width: 20px;
      height: 40px;
      line-height: 40px;
      z-index: 1050;

      &:hover {
        transform: scale(1.2);
        transition: 0.5s all;
      }
    }
  }
</style>
